<template>
  <div>
    <ServicesHero
      v-if="!authenticated"
      :initial-fields="initialFields"
      :title="titlePage"
      :image="heroImage"
      download-text="Brochure"
    >
      <template #extra-ctas>
        <ButtonBookADemo />
      </template>
    </ServicesHero>

    <div
      class="mx-auto flex w-full max-w-content-container flex-col justify-center gap-y-7 px-small pb-20 pt-8 md:items-start xl:pb-36 xl:pl-16 xl:pr-0 xl:pt-10"
    >
      <Breadcrumb v-if="authenticated" :menu="breadcrumbStore.items" />
      <SectionTitle :title="titlePage" :icon="icon" />

      <section class="w-full lg:rounded-xl lg:bg-white lg:p-6 lg:shadow-pm">
        <div
          class="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between"
        >
          <TheTabsBySlug
            :tabs="tabs"
            @active-tab-changed="$emit('setActiveTab', $event)"
          />
          <slot name="downloadButton" />
        </div>
        <div class="relative pt-6">
          <slot />
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import TheTabsBySlug from '~/components/common/TheTabsBySlug.vue'
import SectionTitle from '~/components/price-assessments/SectionTitle.vue'
import Breadcrumb from '~/components/shared/navigation/Breadcrumb.vue'
import ServicesHero from '~/components/shared/services/Hero.vue'
import ButtonBookADemo from '~/components/shared/common/ButtonBookADemo.vue'

import { useScrollPosition } from '~/composables/useScrollPosition'
import { MARKET } from '~/constants/services/constants'
import type { TRecord, TTab } from '~/src/types/common'

const props = defineProps<{
  product: TRecord
  heroImage: string
  tabs: TTab[]
  activeTab?: string
}>()

defineEmits<{
  setActiveTab: [string | null]
}>()

const { scrollToPosition } = useScrollPosition()
const breadcrumbStore = useBreadcrumbStore()
const authStore = useAuthStore()

const titlePage = computed(() => `${props.product.name} Data & Reports`)
const icon = computed(() => props.product.iconColor)
const heroImage = computed(() => props.heroImage)
const initialFields = computed(() => [props.product.slug, MARKET.slug])
const authenticated = computed(() => authStore.authenticated)

onMounted(() => {
  scrollToPosition()
})
</script>
